import { render, staticRenderFns } from "./Carpetas.vue?vue&type=template&id=3ec70243&scoped=true&"
import script from "./Carpetas.vue?vue&type=script&lang=js&"
export * from "./Carpetas.vue?vue&type=script&lang=js&"
import style0 from "./Carpetas.vue?vue&type=style&index=0&id=3ec70243&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec70243",
  null
  
)

export default component.exports